module.exports = __webpack_public_path__ + "img/email-header-feedback@2x.244554e6.png";